const globalActionTypes  = {
    LOADER_START: "LOADER_START",
    LOADER_MINI_START:"LOADER_MINI_START",
    LOADER_MINI_REMOVE:"LOADER_MINI_REMOVE",
    LOADER_REMOVE: "LOADER_REMOVE",
    MESSAGE: "MESSAGE",
    ERROR: "ERROR",
    TOGGLE_THEME:"TOGGLE_THEME",
    CLEAR_GLOBAL_STATE: "CLEAR_GLOBAL_STATE",
    RESET_MESSAGE:"RESET_MESSAGE",
    RESET_ERROR:"RESET_ERROR"

};




export default globalActionTypes;